<homey-page-title title="Reset password"/>
@if (linkExpired()) {
  <p-message severity="warn" class="block mb-4">
    This password reset link has expired. Request a new link to continue.
  </p-message>
  @if (resendSuccess()) {
    <p-message severity="success" class="block mb-4">
      <span>We sent a new reset link to <span class="font-medium break-all">{{ email || 'your email' }}</span>. Please check your inbox.</span>
    </p-message>
  }
  @if (resendError()) {
    <p-message severity="error" class="block mb-4">
      {{ resendError() }}
    </p-message>
  }
  <homey-submit-button class="w-full" submitButtonLabel="Resend reset link" [submitFunction]="resendResetLink"/>
} @else {
  <p class="mb-4">Enter a new password for your account.</p>
  <homey-custom-form [formGroup]="form" submitButtonLabel="Reset password" [submitFunction]="submit">
    <homey-form-inputs>
      <homey-text-input [inputFormControl]="form.controls.password"
                        inputId="password"
                        label="New password"
                        errorMessage="Your password needs to be at least 8 characters including a lower-case letter, an upper-case letter, a number and one special character (!@#$%^&*)"
                        [type]="{type: 'password', autocomplete: 'new-password'}"/>
    </homey-form-inputs>
  </homey-custom-form>
}
